<div class="row" *ngIf="images$ | async as images">
  <div class="col-12">
    <img class="small mr-1" [src]="i" *ngFor="let i of images" (click)="open(i, template)" />
  </div>
</div>

<ng-template let-data #template>
  <img [src]="data.img" class="mw-100 mh-100" />
</ng-template>

<div class="row" *ngIf="files$ | async as files">
  <div class="col-12">
    <ul class="list-style-none p-0">
      <li *ngFor="let f of files">
        <a target="_blank" [href]="serverUrl + f.path | safe:'resourceUrl'">{{f.filename}}</a>
      </li>
    </ul>
  </div>
</div>
